import api from './api';
import groupAssignmentsMock from '@/mocks/groupAssignments';

function useMock() {
    return process.env.VUE_APP_GROUP_ASSIGNMENTS_MOCK !== 'false';
}

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };
}

export default {
    async list(accessToken, params = {}) {
        if (useMock()) return groupAssignmentsMock.list(params);
        const response = await api.get('/course-group-assignment', {
            headers: authHeaders(accessToken),
            params: {
                search: params.search || undefined,
                groupId: params.groupId || undefined,
                resourceType: params.resourceType || undefined,
                resourceId: params.resourceId || undefined,
                linesPerPage: params.linesPerPage || 100,
            },
        });
        return response.data;
    },

    async getById(id, accessToken) {
        if (useMock()) return groupAssignmentsMock.getById(id);
        const response = await api.get(`/course-group-assignment/${id}`, {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },

    async create(payload, accessToken) {
        if (useMock()) return groupAssignmentsMock.create(payload);
        const response = await api.post('/course-group-assignment', payload, {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },

    async update(id, payload, accessToken) {
        if (useMock()) return groupAssignmentsMock.update(id, payload);
        const response = await api.put(`/course-group-assignment/${id}`, payload, {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },

    async remove(id, accessToken) {
        if (useMock()) return groupAssignmentsMock.remove(id);
        const response = await api.delete(`/course-group-assignment/${id}`, {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },
};
